/**
 * localStorage 安全存取（SSR / 私密瀏覽 / 被封鎖時不拋錯）。
 * 用於 DataTable 欄位個人化（裁決 6-3）：key 需含頁面 id 以避免跨頁互相覆蓋。
 */

export function readJSON<T>(key: string): T | undefined {
  try {
    if (typeof window === "undefined") return undefined;
    const raw = window.localStorage.getItem(key);
    if (!raw) return undefined;
    return JSON.parse(raw) as T;
  } catch {
    return undefined;
  }
}

export function writeJSON(key: string, value: unknown): void {
  try {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // 私密瀏覽 / 配額滿 / 被封鎖：靜默放棄，不影響畫面渲染
  }
}

export function removeKey(key: string): void {
  try {
    if (typeof window === "undefined") return;
    window.localStorage.removeItem(key);
  } catch {
    // 忽略
  }
}
